import PropTypes from 'prop-types'
import { Redirect } from 'react-router-dom'

import injectRole from '../../../components/HOC/injectRole'

import { TRoutes } from '../../../shared/const'
import { mayOpenAdminPage } from '../../../shared/alumni'
import Schools from '../../../components/views/admin/Schools'

function SchoolsPage(props) {
	if (mayOpenAdminPage(props.role, 'schools')) return <Schools />
	else return <Redirect to={TRoutes.DASHBOARD} />
}

SchoolsPage.propTypes = {
	role: PropTypes.string.isRequired
}

export default injectRole(SchoolsPage)
